import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { PENDING_INVITES_KEY } from "@/hooks/hr/calendar/use-calendar-availability";
import { AFFECTS_PENDING_INVITES, calendarKind, isCalendarNotification } from "@/lib/notification-target";

interface N {
  id: string;
  is_read?: boolean;
  reference_type?: string | null;
  reference_id?: string | null;
  data?: Record<string, unknown> | null;
}

/**
 * Quando chega ao sino uma notificação de calendário que mexe nos convites
 * (convite, lembrete de convite, alteração, cancelamento, remoção, resposta),
 * o selo do Calendário na sidebar atualiza logo em vez de esperar pelos 60 s.
 *
 * A primeira lista que se recebe só serve de ponto de partida: o que já lá
 * estava não conta como "chegou agora".
 */
export function useCalendarNotificationSync(notifications: N[] | undefined): void {
  const queryClient = useQueryClient();
  const seen = useRef<Set<string> | null>(null);

  useEffect(() => {
    if (!notifications) return;
    if (seen.current === null) {
      seen.current = new Set(notifications.map((n) => n.id));
      return;
    }
    let affects = false;
    for (const n of notifications) {
      if (seen.current.has(n.id)) continue;
      seen.current.add(n.id);
      const kind = calendarKind(n);
      if (isCalendarNotification(n) && (kind === null || AFFECTS_PENDING_INVITES.includes(kind))) affects = true;
    }
    if (affects) void queryClient.invalidateQueries({ queryKey: PENDING_INVITES_KEY });
  }, [notifications, queryClient]);
}
